import _ from 'lodash';

export default function filterSearchResults(results) {
  return results.filter((resultItem) => (
    !_.isNull(_.get(resultItem, 'item.result'))
  ));
}
